import { isMobile } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';

export default class InfiniteScroll__ItemProjectList extends InfiniteScroll__Item {
    _card;
    _correction = 1;

    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis);

        this._card = GetBy.class('card-project', this.dom)[0];

        this.resize();
        this.update();
    }

    drawHook() {
        if (!this._card) return;

        const PROGRESS = this.progress + this._correction;

        const rot = Maths.lerp(0, -this.opts.rotation.angle, PROGRESS);
        this._card.style[CSS.transform] = CSS.rotate3D(0, 0, 1, rot);
    }

    resize() {
        super.resize();

        this._correction = isMobile ? 0 : 1;
    }
}
